import React, { useEffect, useState } from "react";
import logo from "../Assets/Rukmani_logo.png";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";

function RajasthaniGallery() {
  const [allImages, setAllImages] = useState([]);
  useEffect(() => {
    fetch("https://jewellery-mysql-backend.onrender.com/admin/images")
      .then((res) => res.json())
      .then((data) => {
        const rajasthaniImages = data.data.filter(
          (image) => image.category === "Rajasthani" );
        setAllImages(rajasthaniImages);
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
        setAllImages([]); 
      });
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <div className="catalog-gallery-wrapper">
        <div className="catalog_gallery_all">
          <div className="photo_shop_bar">
            <div className="nav-logo">
              <img className="logo-img" src={logo} alt="logo" />
            </div>
            <div>
              <p className="photo_shop">Shree Rupmani Jewellers</p>
            </div>
          </div>
          <div className="">
            <button
              className="button border rounded mt-4 ml-4 px-2 bg-red-500 text-white shadow hover:bg-red-600"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <div className="catalog_gallery items-center">
              <div className="heading">
                <h2 className="font-semibold text-center flex text-2xl text-red-900">
                  RajasthaniGold Gallery
                </h2>
              </div>
              <div className="w-[80%] rounded m-auto ">
                <div className="flex flex-wrap justify-center">
                  {allImages.length > 0 ? (
                    allImages.map((image) => (
                      <div
                        className="flex flex-wrap justify-center bg-red-50 rounded"
                        key={image.id}
                      >
                        <img className="w-full h-48 hover:scale-105 transition-transform" src={`https://jewellery-mysql-backend.onrender.com/public/${image.imageUrl}`} alt={image.category} />
                      </div>
                    ))
                  ) : (
                    <p>No images found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default RajasthaniGallery;
